// import Icon from '@ant-design/icons';
import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import MultiProgress from 'react-multi-progress'
import { FaMaximize, FaMinimize } from "react-icons/fa6";


import {
    Table,
    Spin,
    Row,
    Col,
    Button,
    Input,
    Modal,
    Checkbox,
    notification,
    Form,
    message,
    Tooltip
} from "antd";
import {
    LoadingOutlined,
    FileExcelOutlined,
    FileTextOutlined,
    ExclamationCircleOutlined,
    CloseOutlined,
    LeftOutlined,
    RightOutlined,
} from "@ant-design/icons";
// import { DownloadOutlined } from '@ant-design/icons';
import { createRoute, getStyleProperties } from "../../utils/CustomFunc";
import { css } from "@emotion/css";
import moment from "moment";
import { CSVLink, CSVDownload } from "react-csv";
import ImageView from "../ImageView/ImageView";
import TableModal from "../Tables/TableModal";
import liracrypt from "../Liracrypt/liracrypt";
import HModal from "../../pages/HModal";
import FooterButtons from "../STORM/FooterButtons";
import Scanter from "../STORM/Scanter";
import ZenMultiLines from "./ZenMultiLines";
import ZenModal from "../ZenModal";
import noImg from '../../assets/static/noImg.jpeg'
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import { useSelector } from "react-redux";
import ScrollBlock from "../ScrollBlock";
import { useLocation } from 'react-router-dom';
import queryString from "query-string";
import ImageSlideShow from "../../pages/ImageSlideShow";
import UniDropAdv from "../ReportFormGenerator/UniDrop/UniDropAdv";
import ImgDisplay from "../ImgDisplay";

let ColumnClass = [{ defualt: {} }];

//const { confirm } = Modal;

const ZenTablePrime = ({ fetchTblConfigData, tblConfig, editColumn, widthClass = '', routeModalData, toggleRouteModal, setTblConfig, formData }) => {
    const urlCode = useSelector(state => state.urlCode);
    const [tblLoading, setTblLoading] = useState(false);
    const [relayTaskModal, setRelayTaskModal] = useState({ visible: false, msg: "", title: "", msgStyle: {}, width: 400, closable: false });
    const [dropdownForm] = Form.useForm();
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const { Column, ColumnGroup } = Table;
    const [zenModal, setZenModal] = useState();
    const [barCode, setBarCode] = useState("");
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });

    const toggleModal = ({ show = false, data = undefined, type = '', loading = false }) => {
        setModal({ show, data, type, loading });
    }
    const [selectedButton, setSelectedButton] = useState();
    const [data, setData] = useState({
        tblConfig: null,
        column: null,
        data: null,
        searchData: null,
    });

    const [btnloading, setBtnLoading] = useState({});

    const [modData, setModData] = useState(null);
    const [visible, setVisible] = useState(false);
    const [type, setType] = useState(null);

    const [loading, setLoading] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);

    const [mount, setMount] = useState(false);
    const [acData, setAcData] = useState(null);

    const [stableModalVisible, setStableModalVisible] = useState(false);
    const [record, setRecord] = useState(null);
    const [stableUrl, setStableUrl] = useState(null);
    const [stableAuxData, setStableAuxData] = useState(null);
    const [stableType, setStableType] = useState(null);
    const [tabeLimitPerPage, setTableLimitPerPage] = useState(tblConfig?.config?.tableConfig?.noOfRows || 10);

    const [changer, setChanger] = useState(false);

    const [action, setAction] = useState({});
    const [isHModalVisible, setIsHModalVisible] = useState(false);
    const [modalMethod, setModalMethod] = useState(null);

    const [selectedRowData, setSelectedRowData] = useState([]);
    const [defaultPage, setDefaultPage] = useState(1)
    const [r, setR] = useState(null);

    useEffect(() => {
        if (tblConfig.config.buttons) {
            tblConfig.config.buttons.map((bItem, index) => {
                let curBtnState = {};
                curBtnState[bItem["label"]] = false;
                let newBtnState = { ...btnloading, ...curBtnState };
                setBtnLoading(newBtnState);
            });
        };
        if (tblConfig?.config?.tableConfig?.autoPagination) {
            let timeInterVal = (tblConfig?.config?.tableConfig?.intervalPaginationSec || 1) * 1000;
            let totalNumberOfPages = Math.ceil(tblConfig.data.length / tabeLimitPerPage);
            let autoPaginate = setInterval(() => {
                setDefaultPage(prev => prev === totalNumberOfPages ? 1 : prev + 1);
            }, timeInterVal);
            return (() => clearInterval(autoPaginate));
        }
    }, []);

    const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
    let tblClass = css({});

    if (tblConfig && tblConfig.config) {
        tblClass = css({
            "&": {
                backgroundColor: tblConfig.config.footer["background-color"]
                    ? tblConfig.config.footer["background-color"] + " !important"
                    : "#021B2A !important",
                // padding: "10px 20px"
            },
            "& table": {
                borderCollapse: "collapse",
                tableLayout: 'fixed !important'
            },
            "& thead > tr > th, & thead > tr > th.ant-table-column-has-sorters:hover":
            {
                ...getStyleProperties(tblConfig.config.header),
                backgroundColor: tblConfig.config.header["background-color"]
                    ? tblConfig.config.header["background-color"] + " !important"
                    : "#577b90 !important",
                borderBottomColor: tblConfig.config.tableConfig["line-color"]
                    ? tblConfig.config.tableConfig["line-color"]
                    : "#f0f0f0",
                padding: tblConfig.config.header["row-padding"] ? tblConfig.config.header["row-padding"] + " !important" : "0px"
            },
            "& thead > tr > th .ant-table-column-sorters": {
                padding: tblConfig.config.header["row-padding"]
                    ? tblConfig.config.header["row-padding"] + " !important"
                    : "0px",
                display: "block",
            },
            "& thead > tr > th .ant-table-column-sorters > .ant-table-column-sorter-full":
            {
                float: "right",
            },
            "& tbody > tr > td.ant-table-selection-column, & tbody > tr:hover > td.ant-table-selection-column": {
                backgroundColor: `${tblConfig.config.row["background-color"]} !important`,
            },
            "& tbody > tr > td, & tbody > tr:hover > td": {
                ...getStyleProperties(tblConfig.config.row),
                //    backgroundColor: `${tblConfig.config.row["background-color"]} !important`,
                borderBottomColor: tblConfig.config.row["border-bottom-color"]
                    ? tblConfig.config.row["border-bottom-color"] + " !important"
                    : "#1b323f",
                borderTopColor: tblConfig.config.row["border-top-color"]
                    ? tblConfig.config.row["border-top-color"] + " !important"
                    : "#1b323f",
                borderTop: tblConfig.config.row["border-top-color"]
                    ? '1px solid' + tblConfig.config.row["border-top-color"] + " !important"
                    : "",
                padding: tblConfig.config.row["row-padding"]
                    ? tblConfig.config.row["row-padding"] + " !important"
                    : "0px",
                //   backgroundColor: tblConfig.config.row["background-color"] + " !important"
            },
            "& thead > tr > th.ant-table-column-has-sorters:hover, & thead > tr > th.ant-table-column-sort":
            {
                backgroundColor: tblConfig.config.header["hover-color"]
                    ? tblConfig.config.header["hover-color"] + " !important"
                    : "#577b90 !important",
            },
            // "& thead > tr > th:first-child": {
            //     paddingLeft: "20px !important",
            // },
            "& tbody > tr:hover > td": {
                backgroundColor: tblConfig.config.row["hover-color"]
                    ? tblConfig.config.row["hover-color"] + " !important"
                    : "",
            },
            "& .ant-table-footer .zen-multi-footer": {
                backgroundColor: tblConfig.config.footerMultiline["background-color"]
                    ? tblConfig.config.footerMultiline["background-color"] + " !important"
                    : "#0b1923 !important",
            },

            "& .ant-pagination-item a, & .ant-pagination-prev button, & .ant-pagination-next button, & .ant-pagination-jump-prev .ant-pagination-item-container .ant-pagination-item-ellipsis, &  .ant-pagination-jump-next .ant-pagination-item-container .ant-pagination-item-ellipsis":
            {
                color: tblConfig.config.footer["pagination-color"]
                    ? tblConfig.config.footer["pagination-color"] + " !important"
                    : "#000000 !important",
                fontsize: tblConfig.config.footer["font-size"]
                    ? tblConfig.config.footer["font-size"] + " !important"
                    : "12px !important",
                fontWeight: tblConfig.config.footer["font-weight"]
                    ? tblConfig.config.footer["font-weight"] + " !important"
                    : "normal !important",
            },

            "& .ant-pagination-item, & .ant-pagination-prev .ant-pagination-item-link, & .ant-pagination-next .ant-pagination-item-link":
            {
                backgroundColor: tblConfig.config.footer["background-color"]
                    ? tblConfig.config.footer["background-color"] + " !important"
                    : "#fff !important",
                borderColor: tblConfig.config.footer["background-color"]
                    ? tblConfig.config.footer["background-color"] + " !important"
                    : "#fff !important",
                fontsize: tblConfig.config.footer["font-size"]
                    ? tblConfig.config.footer["font-size"] + " !important"
                    : "12px !important",
                fontWeight: tblConfig.config.footer["font-weight"]
                    ? tblConfig.config.footer["font-weight"] + " !important"
                    : "normal !important",
            },
            "& .ant-pagination-item-active": {
                borderColor: tblConfig.config.footer["pagination-color"]
                    ? tblConfig.config.footer["pagination-color"] + " !important"
                    : "#fff !important",
                fontsize: tblConfig.config.footer["font-size"]
                    ? tblConfig.config.footer["font-size"] + " !important"
                    : "12px !important",
                fontWeight: tblConfig.config.footer["font-weight"]
                    ? tblConfig.config.footer["font-weight"] + " !important"
                    : "normal !important",
                color: tblConfig.config.footer["pagination-color"]
                    ? tblConfig.config.footer["pagination-color"] + " !important"
                    : "#fff !important"
            },
            // "& .ant-table tr td": {
            //     backgroundColor: 'yellow !important'
            // },
            "& .ant-select": {
                color: "#fff !important",
                fontsize: tblConfig.config.footer["font-size"]
                    ? tblConfig.config.footer["font-size"] + " !important"
                    : "12px !important",
                fontWeight: tblConfig.config.footer["font-weight"]
                    ? tblConfig.config.footer["font-weight"] + " !important"
                    : "normal !important",
            },
            "& .ant-select-single:not(.ant-select-customize-input) .ant-select-selector":
            {
                backgroundColor: "transparent !important",
                fontsize: tblConfig.config.footer["font-size"]
                    ? tblConfig.config.footer["font-size"] + " !important"
                    : "12px !important",
                fontWeight: tblConfig.config.footer["font-weight"]
                    ? tblConfig.config.footer["font-weight"] + " !important"
                    : "normal !important",
            },
        });
    }

    const getDivStyle = () => {
        let style = {
            paddingLeft: data.tblConfig.tableConfig.innerLeftPadding
                ? data.tblConfig.tableConfig.innerLeftPadding
                : "0px",
            paddingBottom: data.tblConfig.tableConfig.InnerBottomPadding
                ? data.tblConfig.tableConfig.InnerBottomPadding
                : "0px",
            paddingTop: data.tblConfig.tableConfig.InnerTopPadding
                ? data.tblConfig.tableConfig.InnerTopPadding
                : "0px",
            paddingRight: data.tblConfig.tableConfig.innerRightPadding
                ? data.tblConfig.tableConfig.innerRightPadding
                : "0px",
            width: data.tblConfig.tableConfig.tableWidth
                ? `${data.tblConfig.tableConfig.tableWidth}`
                : "100%",
            // backgroundColor: (data.tblConfig.tableConfig.divBackgroundColor) ? data.tblConfig.tableConfig.divBackgroundColor : "transparent"
        };
        if (data.tblConfig.tableConfig.divBackgroundColor) {
            const bg = data.tblConfig.tableConfig.divBackgroundColor;
            style["background"] = `linear-gradient(to right, ${bg[0]}, ${bg[1]})`;
        }
        if (data.tblConfig.tableConfig.divAlignment) {
            switch (data.tblConfig.tableConfig.divAlignment) {
                case "left":
                    style["marginLeft"] = data.tblConfig.tableConfig.leftMargin
                        ? data.tblConfig.tableConfig.leftMargin
                        : "0px";
                    break;
                case "center":
                    style["margin"] = "0 auto";
                    break;
                default:
                    break;
            }
        }
        return style;
    };

    const zenPopupAction = (zenPopup, value, record) => {
        let urlData = { ...searchParams, ...formData, ...zenPopup.params };
        if (zenPopup?.props) {
            const val = value;
            if (Array.isArray(val) || (typeof val === 'object')) {
                urlData[zenPopup.props] = JSON.stringify(val);
            } else {
                urlData[zenPopup.props] = val;
            }
        }

        if (zenPopup?.multiProps) {
            zenPopup.multiProps.forEach((prop) => {
                const val = record[prop];
                if (Array.isArray(val) || (typeof val === 'object')) {
                    urlData[prop] = JSON.stringify(val);
                } else {
                    urlData[prop] = val;
                }
            });
        }

        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    if (popData?.editDoc) {
                        let data = [...tblConfig.data];
                        let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                        data[updateIndex] = response.data.data
                        setTblConfig({
                            ...tblConfig,
                            data
                        })
                    }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    if (popData?.editDoc) {
                        let data = [...tblConfig.data];
                        let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                        data[updateIndex] = response.data.data
                        setTblConfig({
                            ...tblConfig,
                            data
                        })
                    }
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    if (popData?.editDoc) {
                        let data = [...tblConfig.data];
                        let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                        data[updateIndex] = response.data.data
                        setTblConfig({
                            ...tblConfig,
                            data
                        })
                    }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = ({ record, col, zenPop }) => {
        if (col?.zenPop || zenPop) {
            let zenPopDataIndex = zenPop || tblConfig.config.zenPop[col.data_index];
            setZenModal(zenPopDataIndex);
            if (zenPopDataIndex?.typ === 'newTab') {
                let zenParams = { ...searchParams, ...formData, ...zenPopDataIndex.params };
                if (zenPopDataIndex?.api) {
                    zenParams.api = zenPopDataIndex?.api;
                }
                let route = createRoute({
                    props: zenPopDataIndex?.props,
                    record,
                    multiProps: zenPopDataIndex?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPopDataIndex?.typ === 'confirmationPopUp') {
                let urlData = { ...searchParams, ...formData, ...zenPopDataIndex?.onOk?.params };
                if (zenPopDataIndex?.onOk?.multiProps) {
                    zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
                        urlData[prop] = record[prop];
                    });
                };
                if (zenPopDataIndex?.onOk?.props) {
                    urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
                }

                Modal.confirm({
                    title: zenPopDataIndex?.text,
                    okText: zenPopDataIndex?.okButtonText,
                    cancelText: zenPopDataIndex?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPopDataIndex?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

        }
    }

    const onSearchPlan = (value) => {
        if (value) {
            let val = value.toLowerCase();
            const newData = data.data.filter((obj) => {
                let search = false;
                for (let index = 0; index < data.column.length; index++) {
                    const element = data.column[index];

                    if (
                        obj.hasOwnProperty(element.dataIndex) &&
                        obj[element.dataIndex] !== null &&
                        obj[element.dataIndex].toString().toLowerCase().indexOf(val) > -1
                    ) {
                        search = true;
                        break;
                    }
                }
                return search;
            });
            let dataNew = { ...data };
            dataNew.searchData = newData;
            setData(dataNew);
            setModData(newData);
        } else {
            let dataNew = { ...data };
            dataNew.searchData = dataNew.data;
            setData(dataNew);
        }
    };

    const onPageChange = () => {
        let totalNumberOfPages = Math.ceil(tblConfig.data.length / tabeLimitPerPage);
        console.log(totalNumberOfPages, defaultPage);
    }

    const getHead = (column) => {
        let d = [];
        let removeList = {};

        if (tblConfig.data) {
            tblConfig.data.forEach((value, index) => {
                if (value.cellColor) {
                    let cData = value.cellColor;
                    Object.keys(cData).forEach((key, index) => {
                        removeList[key + "COLOR"] = true;
                    });
                }
            });
        }

        // console.log(removeList);

        column.forEach((data, index) => {
            let temp = {};
            if (!(data["dataIndex"] in removeList)) {
                temp["label"] = data["label"];
                temp["key"] = data["dataIndex"];
                if (data["label"] !== "") {
                    d.push(temp);
                }
            } else {
                temp["label"] = data["label"];
                temp["key"] = data["dataIndex"].substr(0, data["dataIndex"].length - 5);
                if (data["label"] !== "") {
                    d.push(temp);
                }
            }
        });
        return d;
    };

    const GetTable = ({ d }) => {
        const [v, setV] = useState("");
        return (
            <div className="test123"
                style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: data.tblConfig.tableSubTitle["container-padding"]
                        ? data.tblConfig.tableSubTitle["container-padding"]
                        : "0px",
                    backgroundColor: data.tblConfig.tableSubTitle[
                        "container-background-color"
                    ]
                        ? data.tblConfig.tableSubTitle["container-background-color"]
                        : "transparent",
                }}
            >
                <div
                    style={{
                        ...getStyleProperties(data.tblConfig.tableSubTitle),
                        width: 'auto'
                        //    marginBottom: "10px",
                    }}
                >
                    <span className="iconContainer">
                        <i
                            className={"fa " + data.tblConfig.tableSubTitle["title-icon"]}
                            style={{
                                fontSize: data.tblConfig.tableSubTitle["title-icon-size"],
                                color: data.tblConfig.tableSubTitle["title-icon-color"],
                            }}
                        />
                    </span>
                    {data.tblConfig.tableSubTitle["title-label"]}
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flex: 1 }}>
                    {
                        tblConfig.config.dropdownList?.length && (
                            <div className="customer-complaint" style={{ width: '40%', margin: 0 }}>
                                <div className="customer-form">
                                    <Form
                                        name="ReportForm"
                                        labelWrap={true}
                                        form={dropdownForm}
                                        labelCol={{ span: 8 }}
                                        layout={"vertical"}
                                        colon={false}
                                        onFinish={() => { }}
                                        size="middle"
                                    >
                                        <Row>
                                            {
                                                tblConfig.config.dropdownList.map((dropdown, dIndex) => (
                                                    dropdown.visible !== false &&
                                                    <Col key={`dropdown-${dIndex}`} className={"zen-table-form"} span={dropdown.colSize || 12} style={{ marginBottom: 0 }}>
                                                        <UniDropAdv
                                                            maxHeight={30}
                                                            controlHeight={20}
                                                            LocalDict={[]}
                                                            onChange={() => {
                                                                setTblLoading(true);
                                                                fetchTblConfigData({
                                                                    showLoading: true,
                                                                    extraData: dropdownForm.getFieldsValue(),
                                                                    cb: () => setTblLoading(false)
                                                                })
                                                            }}
                                                            labelCol={8}
                                                            bg={data.tblConfig.tableSubTitle["search-inner-color"]}
                                                            form={dropdownForm}
                                                            colSpan={12}
                                                            multiSelect={dropdown.multiSelect}
                                                            url={
                                                                dropdown.url
                                                                    ? dropdown.url
                                                                    : dropdown.source === "mdict"
                                                                        ? "/mdict"
                                                                        : dropdown.source === "usergroup"
                                                                            ? "/usergroup"
                                                                            : dropdown.source === "cropdown"
                                                                                ? "/cropdown"
                                                                                : dropdown.source === "dynamic"
                                                                                    ? "/dynamicDropdown"
                                                                                    : ""
                                                            }
                                                            disabled={false}
                                                            options={dropdown.data}
                                                            source={dropdown.source}
                                                            // extraData={extraData}
                                                            urlData={{ ...searchParams, ...formData, ...dropdown.sourceParams }}
                                                            pname={dropdown.p_data_index || `p_${dropdown.data_index}`}
                                                            name={dropdown.data_index}
                                                            label={""}
                                                            errorMessage={"Please Select "}
                                                            required={true}
                                                            placeholder={dropdown.placeHolder}
                                                            defaultValue={dropdown.default}
                                                            includeAll={dropdown.includeAll}
                                                            searchable={dropdown.isSearchable}
                                                        />
                                                    </Col>
                                                ))
                                            }
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                        )
                    }

                    {data.tblConfig.tableConfig.isSearchable ? (
                        <div className="inlineBlock">
                            <Input
                                placeholder="Search..."
                                value={v}
                                onChange={(e) => {
                                    setV(e.target.value);
                                }}
                                onPressEnter={() => {
                                    onSearchPlan(v);
                                }}
                                className="searchInput-antd-table"
                                style={{
                                    width: "200px",
                                    maxHeight: 30,
                                    backgroundColor: data.tblConfig.tableSubTitle["search-inner-color"],
                                    color: '#9c9c9c',
                                    border: data.tblConfig.tableSubTitle["search-border-color"]
                                }}
                            />
                        </div>
                    ) : null}
                    {data.tblConfig.tableConfig.exportToCsv && data.searchData ? (
                        <div className="inlineBlock">
                            <Button
                                style={{ backgroundColor: "transparent", border: "none", paddingTop: 0 }}
                                onClick={() => {
                                    setType("csv");
                                    setVisible(true);
                                }}
                                icon={
                                    <FileExcelOutlined
                                        style={{
                                            fontSize: "24px",
                                            color: data.tblConfig.tableSubTitle["download-icon-color"]
                                                ? data.tblConfig.tableSubTitle["download-icon-color"]
                                                : "#ffffff",
                                        }}
                                    />
                                }
                            ></Button>
                        </div>
                    ) : null}
                    {data.tblConfig.tableConfig.exportToPdf ? (
                        <div className="inlineBlock">
                            <Button
                                style={{ backgroundColor: "transparent", border: "none", paddingTop: 0 }}
                                icon={
                                    <FileTextOutlined
                                        style={{
                                            fontSize: "24px",
                                            color: data.tblConfig.tableSubTitle["download-icon-color"]
                                                ? data.tblConfig.tableSubTitle["download-icon-color"]
                                                : "#ffffff",
                                        }}
                                    />
                                }
                                onClick={() => {
                                    setType("txt");
                                    setVisible(true);
                                }}
                            />
                        </div>
                    ) : null}
                    {
                        data.tblConfig.tableConfig.headerNavigation && (
                            <div className="inlineBlock">
                                <Tooltip title="Prev Page">
                                    <Button
                                        ghost={true}
                                        className="nav-btn"
                                        size="small"
                                        style={{
                                            marginRight: 10,
                                            visibility: defaultPage === 1 ? 'hidden' : 'visible'
                                        }}
                                        shape='circle'
                                        type="primary"
                                        disabled={defaultPage === 1} onClick={() => setDefaultPage(defaultPage - 1)} icon={
                                            <LeftOutlined />
                                        }>{''}</Button>
                                </Tooltip>
                                <Tooltip title="Next Page">
                                    <Button
                                        className="nav-btn"
                                        size="small"
                                        style={{
                                            marginLeft: 10,
                                            marginRight: 10,
                                            visibility: Math.ceil(tblConfig.data.length / tabeLimitPerPage) === defaultPage ? 'hidden' : 'visible'
                                        }}
                                        ghost={true}
                                        shape='circle'
                                        type="primary"
                                        disabled={Math.ceil(tblConfig.data.length / tabeLimitPerPage) === defaultPage} onClick={() => setDefaultPage(defaultPage + 1)}
                                        icon={
                                            <RightOutlined />
                                        }>{''}</Button>
                                </Tooltip>
                            </div>
                        )
                    }
                    {
                        data.tblConfig.tableConfig.maximize && (
                            <div className="inlineBlock">
                                <Tooltip title="Maximize">
                                    <Button
                                        ghost={true}
                                        className="nav-btn"
                                        size="small"
                                        shape="circle"
                                        style={{
                                            marginRight: 10,
                                            border: 'none'
                                        }}
                                        type="link"
                                        onClick={() => onColumnClick({ record: {}, zenPop: data.tblConfig.tableConfig.maximize })} icon={
                                            <FaMaximize />
                                        }>{''}</Button>
                                </Tooltip>
                            </div>
                        )
                    }
                </div>
            </div >
            // <Row
            //     className="test123"
            //     justify="space-around"
            //     align="bottom"
            //     style={{
            //         alignItems: 'center',
            //         padding: data.tblConfig.tableSubTitle["container-padding"]
            //             ? data.tblConfig.tableSubTitle["container-padding"]
            //             : "0px",
            //         backgroundColor: data.tblConfig.tableSubTitle[
            //             "container-background-color"
            //         ]
            //             ? data.tblConfig.tableSubTitle["container-background-color"]
            //             : "transparent",
            //     }}
            // >
            //     <Col span={6}>
            //         <div
            //             style={{
            //                 ...getStyleProperties(data.tblConfig.tableSubTitle),
            //                 //    marginBottom: "10px",
            //             }}
            //         >
            //             <span className="iconContainer">
            //                 <i
            //                     className={"fa " + data.tblConfig.tableSubTitle["title-icon"]}
            //                     style={{
            //                         fontSize: data.tblConfig.tableSubTitle["title-icon-size"],
            //                         color: data.tblConfig.tableSubTitle["title-icon-color"],
            //                     }}
            //                 />
            //             </span>
            //             {data.tblConfig.tableSubTitle["title-label"]}
            //         </div>
            //     </Col>
            //     <Col span={18} style={{ alignItems: 'center', justifyContent: 'flex-end', display: 'flex', marginTop: 5, marginBottom: 5 }}>
            //         {
            //             tblConfig.config.dropdownList?.length && (
            //                 <div className="customer-complaint" style={{ width: '40%', margin: 0 }}>
            //                     <div className="customer-form">
            //                         <Form
            //                             name="ReportForm"
            //                             labelWrap={true}
            //                             form={dropdownForm}
            //                             labelCol={{ span: 8 }}
            //                             layout={"vertical"}
            //                             colon={false}
            //                             onFinish={() => { }}
            //                             size="middle"
            //                         >
            //                             <Row>
            //                                 {
            //                                     tblConfig.config.dropdownList.map((dropdown, dIndex) => (
            //                                         dropdown.visible !== false &&
            //                                         <Col key={`dropdown-${dIndex}`} className={"zen-table-form"} span={dropdown.colSize || 12} style={{ marginBottom: 0 }}>
            //                                             <UniDropAdv
            //                                                 maxHeight={30}
            //                                                 controlHeight={20}
            //                                                 LocalDict={[]}
            //                                                 onChange={() => {
            //                                                     setTblLoading(true);
            //                                                     fetchTblConfigData({
            //                                                         showLoading: true,
            //                                                         extraData: dropdownForm.getFieldsValue(),
            //                                                         cb: () => setTblLoading(false)
            //                                                     })
            //                                                 }}
            //                                                 labelCol={8}
            //                                                 bg={data.tblConfig.tableSubTitle["search-inner-color"]}
            //                                                 form={dropdownForm}
            //                                                 colSpan={12}
            //                                                 multiSelect={dropdown.multiSelect}
            //                                                 url={
            //                                                     dropdown.url
            //                                                         ? dropdown.url
            //                                                         : dropdown.source === "mdict"
            //                                                             ? "/mdict"
            //                                                             : dropdown.source === "usergroup"
            //                                                                 ? "/usergroup"
            //                                                                 : dropdown.source === "cropdown"
            //                                                                     ? "/cropdown"
            //                                                                     : dropdown.source === "dynamic"
            //                                                                         ? "/dynamicDropdown"
            //                                                                         : ""
            //                                                 }
            //                                                 disabled={false}
            //                                                 options={dropdown.data}
            //                                                 source={dropdown.source}
            //                                                 // extraData={extraData}
            //                                                 urlData={{ ...searchParams, ...formData, ...dropdown.sourceParams }}
            //                                                 pname={dropdown.p_data_index || `p_${dropdown.data_index}`}
            //                                                 name={dropdown.data_index}
            //                                                 label={""}
            //                                                 errorMessage={"Please Select "}
            //                                                 required={true}
            //                                                 placeholder={dropdown.placeHolder}
            //                                                 defaultValue={dropdown.default}
            //                                                 includeAll={dropdown.includeAll}
            //                                                 searchable={dropdown.isSearchable}
            //                                             />
            //                                         </Col>
            //                                     ))
            //                                 }
            //                             </Row>
            //                         </Form>
            //                     </div>
            //                 </div>
            //             )
            //         }

            //         {data.tblConfig.tableConfig.isSearchable ? (
            //             <div className="inlineBlock">
            //                 <Input
            //                     placeholder="Search..."
            //                     value={v}
            //                     onChange={(e) => {
            //                         setV(e.target.value);
            //                     }}
            //                     onPressEnter={() => {
            //                         onSearchPlan(v);
            //                     }}
            //                     className="searchInput-antd-table"
            //                     style={{
            //                         width: "200px",
            //                         maxHeight: 30,
            //                         backgroundColor: data.tblConfig.tableSubTitle["search-inner-color"],
            //                         color: '#9c9c9c',
            //                         border: data.tblConfig.tableSubTitle["search-border-color"]
            //                     }}
            //                 />
            //             </div>
            //         ) : null}
            //         {data.tblConfig.tableConfig.exportToCsv && data.searchData ? (
            //             <div className="inlineBlock">
            //                 <Button
            //                     style={{ backgroundColor: "transparent", border: "none", paddingTop: 0 }}
            //                     onClick={() => {
            //                         setType("csv");
            //                         setVisible(true);
            //                     }}
            //                     icon={
            //                         <FileExcelOutlined
            //                             style={{
            //                                 fontSize: "24px",
            //                                 color: data.tblConfig.tableSubTitle["download-icon-color"]
            //                                     ? data.tblConfig.tableSubTitle["download-icon-color"]
            //                                     : "#ffffff",
            //                             }}
            //                         />
            //                     }
            //                 ></Button>
            //                 ;
            //             </div>
            //         ) : null}
            //         {data.tblConfig.tableConfig.exportToPdf ? (
            //             <div className="inlineBlock">
            //                 <Button
            //                     style={{ backgroundColor: "transparent", border: "none", paddingTop: 0 }}
            //                     icon={
            //                         <FileTextOutlined
            //                             style={{
            //                                 fontSize: "24px",
            //                                 color: data.tblConfig.tableSubTitle["download-icon-color"]
            //                                     ? data.tblConfig.tableSubTitle["download-icon-color"]
            //                                     : "#ffffff",
            //                             }}
            //                         />
            //                     }
            //                     onClick={() => {
            //                         setType("txt");
            //                         setVisible(true);
            //                     }}
            //                 />
            //             </div>
            //         ) : null}
            //         {
            //             data.tblConfig.tableConfig.headerNavigation && (
            //                 <div className="inlineBlock">
            //                     <Tooltip title="Prev Page">
            //                         <Button
            //                             ghost={true}
            //                             className="nav-btn"
            //                             size="small"
            //                             style={{
            //                                 marginRight: 10,
            //                                 visibility: defaultPage === 1 ? 'hidden' : 'visible'
            //                             }}
            //                             shape='circle'
            //                             type="primary"
            //                             disabled={defaultPage === 1} onClick={() => setDefaultPage(defaultPage - 1)} icon={
            //                                 <LeftOutlined />
            //                             }>{''}</Button>
            //                     </Tooltip>
            //                     <Tooltip title="Next Page">
            //                         <Button
            //                             className="nav-btn"
            //                             size="small"
            //                             style={{
            //                                 marginLeft: 10,
            //                                 marginRight: 10,
            //                                 visibility: Math.ceil(tblConfig.data.length / tabeLimitPerPage) === defaultPage ? 'hidden' : 'visible'
            //                             }}
            //                             ghost={true}
            //                             shape='circle'
            //                             type="primary"
            //                             disabled={Math.ceil(tblConfig.data.length / tabeLimitPerPage) === defaultPage} onClick={() => setDefaultPage(defaultPage + 1)}
            //                             icon={
            //                                 <RightOutlined />
            //                             }>{''}</Button>
            //                     </Tooltip>
            //                 </div>
            //             )
            //         }
            //         {
            //             data.tblConfig.tableConfig.maximize && (
            //                 <div className="inlineBlock">
            //                     <Tooltip title="Maximize">
            //                         <Button
            //                             ghost={true}
            //                             className="nav-btn"
            //                             size="small"
            //                             shape="circle"
            //                             style={{
            //                                 marginRight: 10,
            //                                 border: 'none'
            //                             }}
            //                             type="link"
            //                             onClick={() => onColumnClick({ record: {}, zenPop: data.tblConfig.tableConfig.maximize })} icon={
            //                                 <FaMaximize />
            //                             }>{''}</Button>
            //                     </Tooltip>
            //                 </div>
            //             )
            //         }
            //     </Col>
            // </Row>
        );
    };

    const ModalView = () => {
        return (
            <Modal
                open={visible}
                title="Do you want to download all data ?"
                footer={null}
                closeIcon={
                    <CloseOutlined
                        style={{ color: "#fff" }}
                        onClick={() => setVisible(false)}
                    />
                }
            >
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <CSVLink
                        filename={`${data.tblConfig.tableSubTitle["title-label"]}.${type}`}
                        data={DownloadData(data.data)}
                        headers={getHead(data.column)}
                        style={{ marginRight: "10px" }}
                    >
                        <Button
                            type="primary"
                            style={{ fontWeight: 600 }}
                            onClick={() => setVisible(false)}
                        >
                            Yes
                        </Button>
                    </CSVLink>

                    <CSVLink
                        filename={`${data.tblConfig.tableSubTitle["title-label"]}.${type}`}
                        data={DownloadData(modData)}
                        headers={getHead(data.column)}
                    >
                        <Button
                            type="primary"
                            style={{ fontWeight: 600 }}
                            onClick={() => setVisible(false)}
                        >
                            No
                        </Button>
                    </CSVLink>
                </div>
            </Modal>
        );
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    useEffect(() => {
        setMount(false);

        // if (
        //   tblConfig &&
        //   data.tblConfig === null &&
        //   data.column === null &&
        //   data.data === null
        // ) {
        let newData = {
            tblConfig: {},
            column: {},
            data: {},
            searchData: {},
            dateArray: [],
        };

        var DateArray = new Set();

        if (tblConfig && tblConfig.config) {
            // if (tblConfig.config.header1) {
            //     newData.tblConfig["header1"] = tblConfig.config.header1;
            // }
            // if (tblConfig.config.header2) {
            //     newData.tblConfig["header2"] = tblConfig.config.header2;
            // }
            // if (tblConfig.config.header3) {
            //     newData.tblConfig["header3"] = tblConfig.config.header3;
            // }
            // if (tblConfig.config.header4) {
            //     newData.tblConfig["header4"] = tblConfig.config.header4;
            // }

            if (tblConfig.config.multiColHeaderLabel) {
                newData.tblConfig["multiColHeaderLabel"] =
                    tblConfig.config.multiColHeaderLabel;
            }
            if (tblConfig.config.multiColHeaderValue) {
                newData.tblConfig["multiColHeaderValue"] =
                    tblConfig.config.multiColHeaderValue;
            }
            if (tblConfig.config.multiColValues) {
                newData.tblConfig["multiColValues"] = tblConfig.config.multiColValues;
            }

            if (tblConfig.config.tableTitle) {
                newData.tblConfig["tableTitle"] = tblConfig.config.tableTitle;
            }
            if (tblConfig.config.tableSubTitle) {
                newData.tblConfig["tableSubTitle"] = tblConfig.config.tableSubTitle;
            }
            if (tblConfig.config.tableConfig) {
                newData.tblConfig["tableConfig"] = tblConfig.config.tableConfig;
            }
            if (tblConfig.config.header) {
                newData.tblConfig["header"] = tblConfig.config.header;
            }
            if (tblConfig.config.row) {
                newData.tblConfig["row"] = tblConfig.config.row;
            }

            let suffixList = {};
            let prefixList = {};

            tblConfig.config.column.map((obj, index) => {
                if (obj["suffix"]) {
                    suffixList[obj["data_index"]] = obj["suffix"];
                }
            });

            tblConfig.config.column.map((obj, index) => {
                if (obj["prefix"]) {
                    prefixList[obj["data_index"]] = obj["prefix"];
                }
            });

            const passParam = (record) => {
                let strn = "";
                Object.keys(record).forEach((data, index) => {
                    if (index === 0) {
                        strn = data + "=" + record[data];
                    } else {
                        strn = strn + "&" + data + "=" + record[data];
                    }
                });
                return strn;
            };

            let colorList = {};



            if (tblConfig.data) {
                tblConfig.data.forEach((value, index) => {
                    let codata = {};

                    if (value.cellColor) {
                        // let cData = value.cellColor;

                        // Object.keys(value.cellColor).forEach((d, i) => {
                        //     if (!suffixList[d] && !prefixList[d]) {

                        //         colorList[d] = true;
                        //         value[d + "COLOR"] = (
                        //             <div
                        //                 className={cData[d]}
                        //                 // style={{
                        //                 //     backgroundColor: `${cData[d]["backgroundColor"]}`,
                        //                 //     color: `${cData[d]["fontColor"]}`,
                        //                 //     textAlign: "center",
                        //                 //     borderRadius: "5px",
                        //                 // }}
                        //             >
                        //                 {value[d]}
                        //             </div>
                        //         );
                        //     }
                        // });

                        // Object.keys(suffixList).forEach((key) => {
                        //     if (key in value.cellColor) {
                        //         colorList[key] = true;
                        //         // console.log(value[key].toString(), suffixList[key]);
                        //         value[key + "COLOR"] = (
                        //             <div
                        //                 className={cData[key]}
                        //                 // style={{
                        //                 //     backgroundColor: `${cData[key]["backgroundColor"]}`,
                        //                 //     color: `${cData[key]["fontColor"]}`,
                        //                 //     textAlign: "center",
                        //                 //     borderRadius: "5px",
                        //                 // }}
                        //             >
                        //                 {key in suffixList
                        //                     ? value[key] + suffixList[key]
                        //                     : value[key]}
                        //             </div>
                        //         );
                        //     } else {
                        //         if (key in suffixList) {
                        //             value[key] = value[key] + suffixList[key];
                        //         }
                        //     }
                        // });

                        // Object.keys(prefixList).forEach((key) => {
                        //     if (key in value.cellColor) {
                        //         colorList[key] = true;
                        //         value[key + "COLOR"] = (
                        //             <div
                        //                 className={cData[key]}
                        //                 // style={{
                        //                 //     backgroundColor: `${cData[key]["backgroundColor"]}`,
                        //                 //     color: `${cData[key]["fontColor"]}`,
                        //                 //     textAlign: "center",
                        //                 //     borderRadius: "5px",
                        //                 // }}
                        //             >
                        //                 {key in prefixList && prefixList[key] !== undefined
                        //                     ? prefixList[key] + value[key]
                        //                     : value[key]}
                        //             </div>
                        //         );
                        //     } else {
                        //         if (key in prefixList && prefixList[key] !== undefined) {
                        //             value[key] = prefixList[key] + value[key];
                        //         }
                        //     }
                        // });
                    } else {
                        // Object.keys(suffixList).forEach((key) => {
                        //     if (key in suffixList) {
                        //         value[key] = value[key] + suffixList[key];
                        //     }
                        // });
                        // Object.keys(prefixList).forEach((key) => {
                        //     if (key in prefixList) {
                        //         value[key] = prefixList[key] + value[key];
                        //     }
                        // });
                    }
                });

                newData.searchData = tblConfig.data;
            }

            // console.log(colorList);

            if (tblConfig.config.column) {
                if (editColumn) {
                    let actionBtns = tblConfig?.config?.column.find(x => x._id === 'action');
                    if (!actionBtns) {
                        editColumn.forEach((item) => {
                            tblConfig.config.column.push(item);
                        });
                    }
                }

                newData.column = tblConfig.config.column.map((obj, index) => {
                    let col = {
                        label: obj['label'],
                        title: obj["title"],
                        dataIndex: obj.hasOwnProperty("data_index")
                            ? obj["data_index"] in colorList
                                ? obj["data_index"] + "COLOR"
                                : obj["data_index"]
                            : obj.hasOwnProperty("dataIndex")
                                ? obj["dataIndex"]
                                : "1",
                    };

                    if (obj.hasOwnProperty("width")) {
                        col["width"] = obj["width"];
                    }

                    if (obj.hasOwnProperty("fixed")) {
                        col["fixed"] = obj["fixed"];
                    }

                    if (obj.hasOwnProperty("align")) {
                        col["align"] = obj["align"];
                    }

                    let colmnStyle = {};
                    if (obj.hasOwnProperty("column_color")) {
                        colmnStyle = {
                            "&": {
                                backgroundColor: obj["column_color"] + " !important",
                            },
                            "&:hover": {
                                backgroundColor: obj["column_color"] + " !important",
                            },
                        };
                    } else {
                        colmnStyle = {
                            "&": {
                                backgroundColor: tblConfig.config.row["background-color"]
                                    ? tblConfig.config.row["background-color"] + " !important"
                                    : "transparent",
                            },
                        };
                    }
                    if (index === 0) {
                        colmnStyle["&"]["paddingLeft"] = "20px !important";
                    }
                    col["className"] = css(colmnStyle);
                    col["render"] = (text, record) => {
                        if (obj.default) {
                            text = obj.default;
                        }
                        if (obj.isBar) {
                            return (
                                <MultiProgress
                                    height={10}
                                    backgroundColor={obj.bgColor}
                                    elements={text}
                                />
                            );
                        }
                        if (!text?.toString()) return <></>
                        let className = '';
                        if (record?.cellColor) {
                            className = record?.cellColor[obj.data_index] || '';
                        }
                        if (obj.suffix && text?.toString()) {
                            text = text + obj.suffix
                        }
                        if (obj.prefix && text?.toString()) {
                            text = obj.prefix + text
                        }

                        // if (typeof (text) === 'number') {
                        //     if (className) {
                        //         return <div className={className}>{text}</div>
                        //     } else {
                        //         return <span>{text}</span>
                        //     }
                        // }

                        if (obj.zenPop && !obj.isIntraCellImage) {
                            if (className) {
                                return (
                                    <Tooltip title={obj.toolTipText || text?.toString()}>
                                        <div className={className} type="link" style={{ color: '#ffffff', padding: 0, cursor: 'pointer' }} onClick={() => onColumnClick({ record, col: obj })}>
                                            {
                                                obj.isBool ?
                                                    <span style={{ textTransform: 'capitalize' }}>{text.toString()}</span> :
                                                    <span>{text?.toString() || '--'}</span>
                                            }
                                        </div>
                                    </Tooltip>
                                )
                            } else {
                                return (
                                    <Tooltip title={obj.toolTipText || text?.toString()}>
                                        <div type="link" style={{ color: '#ffffff', fontWeight: 400, padding: 0, cursor: 'pointer' }} onClick={() => onColumnClick({ record, col: obj })}>
                                            {
                                                obj.isBool ?
                                                    <span style={{ textTransform: 'capitalize' }}>{text.toString()}</span> :
                                                    <span>{text?.toString() || '--'}</span>
                                            }
                                        </div>
                                    </Tooltip>
                                )
                            }
                        } else {
                            if (obj.isIntraCellImage) {
                                let zenPopDataIndex = tblConfig.config.zenPop[obj.data_index];
                                let urlData = { ...searchParams, ...formData, ...zenPopDataIndex.params };
                                if (zenPopDataIndex?.props) {
                                    urlData[zenPopDataIndex?.props] = record[zenPopDataIndex?.props];
                                }
                                if (zenPopDataIndex?.multiProps) {
                                    zenPopDataIndex?.multiProps.forEach((prop) => {
                                        urlData[prop] = record[prop];
                                    });
                                }
                                return (
                                    <>
                                        <ImageView
                                            isCacheble={tblConfig.config.zenPop[obj.data_index]?.isCacheable || false}
                                            source={tblConfig.config.zenPop[obj.data_index]?.source || 'dynamic'}
                                            src={record["intracellStatic"]}
                                            _id={record["intraCellImgId"]}
                                            height="100%"
                                            width={tblConfig.config.zenPop[obj.data_index]?.imageWidth || '100%'}
                                            spinSize={40}
                                            urlData={urlData}
                                        />
                                    </>
                                )
                            } else {
                                if (obj.isBool) {
                                    if (className) {
                                        return <div className={className} style={{ textTransform: 'capitalize' }}>{text.toString()}</div>
                                    } else {
                                        return <span style={{ textTransform: 'capitalize' }}>{text.toString()}</span>
                                    }
                                }
                                if (Array.isArray(text)) {
                                    if (className) {
                                        return <div className={className}>{text.join(" , ")}</div>
                                    } else {
                                        return <span>{text.join(" , ")}</span>
                                    }
                                }
                                if (className) {
                                    return <div className={className}>{text}</div>
                                } else {
                                    return <span className={className}>{text}</span>
                                }
                            }
                        }
                    };

                    if (obj.hasOwnProperty("render")) {
                        col["render"] = obj["render"];
                    }

                    if (tblConfig.config.tableConfig.isSortable) {
                        col["sorter"] = (a, b, sortOrder) => {
                            if (a[col.dataIndex] > b[col.dataIndex]) {
                                return 1;
                            }
                            if (a[col.dataIndex] < b[col.dataIndex]) {
                                return -1;
                            }
                            return 0;
                        };
                    }
                    return col;
                });
            }
        }
        newData.dateArray = DateArray;

        setAcData(DateArray);

        if (tblConfig) {
            let set = new Set();
            let localIST = new Set();

            let localISTFormat = {};
            let setFormat = {};

            if (tblConfig.config.column) {
                tblConfig.config.column.forEach((dat) => {
                    if (dat.hasOwnProperty("DtFormat")) {
                        set.add(dat["data_index"]);
                        setFormat[dat["data_index"]] = dat["DtFormat"];
                        if (dat.hasOwnProperty("isIST")) {
                            localIST.add(dat["data_index"]);
                            localISTFormat[dat["data_index"]] = dat["DtFormat"];
                        }
                    }
                });
            }
            if (tblConfig.data) {
                tblConfig.data.forEach((item) => {
                    Object.keys(item).forEach((key) => {
                        if (set.has(key)) {
                            if (item[key]) {
                                let initValue = item[key];
                                if (localIST.has(key)) {
                                    item[key] = moment.utc(item[key])
                                        .add(5, "hours")
                                        .add(30, "minutes")
                                        .format(localISTFormat[key])
                                        .toString();
                                } else {
                                    let isValidDate = moment(item[key]).isValid();
                                    item[key] = moment(item[key])
                                        .format(setFormat[key])
                                    if (!isValidDate) {
                                        item[key] = initValue;
                                    }
                                }
                                // item[key] = moment(item[key])
                                //   .format("MM-DD-YYYY HH:mm:ss")
                                //   .toString();
                            } else {
                                item[key] = "";
                            }
                        }
                    });
                });
            }
        }

        // console.log(tblConfig);

        newData.data = tblConfig.data;
        // console.log(newData);
        setData(newData);


        // setInterval(() => {}, 1000);

        setMount(true);
    }, [tblConfig]);

    const DownloadData = (da) => {
        let localIST = new Set();

        if (tblConfig.config && acData) {
            tblConfig.config.column.forEach((dta, ind) => {
                if (acData.has(dta["data_index"])) {
                    if ("isIST" in dta) {
                        localIST.add(dta["data_index"]);
                    }
                }
            });
        }

        return da || [];
    };

    const finalAction = (action, res) => {
        if (action === "refreshPhantom") {
            notification.success({
                message: res?.data?.message
                    ? res?.data?.message
                    : "Data Modified Successfully !",
            });
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        } else if (action === "refreshStable") {
            document.getElementById("submitButtonForm").click();
        } else {
            notification.success({
                message: res?.data?.message
                    ? res?.data?.message
                    : "Data Modified Successfully !",
            });
        }
    };

    const relayTask = async ({ button, resp }) => {
        let { method, api, params, interval, preMsg, width = 400, title = "Relay Task", closable = false, maxCall, msgStyle } = button.relayTaskProp;
        let urlData = { ...searchParams, ...formData, ...params };
        setRelayTaskModal({ visible: true, msg: preMsg || "Processing...", width, title, closable, msgStyle });
        let newInterval;
        let callCount = 0;
        const relayTaskApi = async () => {
            callCount++;
            let response;
            if (method === 'POST') {
                response = await liracrypt.post(api, urlData);
            }
            if (method === 'GET') {
                response = await liracrypt.get(api, urlData);
            }
            if (method === 'PATCH') {
                response = await liracrypt.patch(api, urlData);
            }

            if (response.data.isSuccess) {
                clearInterval(newInterval);
                setRelayTaskModal({ visible: false, msg: "", width: 400, title: "Relay Task", closable: false });
                onResponse({ button, onlyPostSubmitAction: true, response: resp });
                return true;
            } else {
                setRelayTaskModal({ ...relayTaskModal, msg: response.data.message || preMsg });
                if (maxCall && (callCount >= maxCall)) {
                    clearInterval(newInterval);
                    setRelayTaskModal({ visible: false, msg: "", width: 400, title: "Relay Task", closable: false });
                }
                return false;
            }
        };

        const firstSuccess = await relayTaskApi();

        if (!firstSuccess) {
            newInterval = setInterval(relayTaskApi, interval);
        }

    };

    const onResponse = ({ button, onlyPostSubmitAction, response }) => {

        // setStormResponse(data);
        let btnData = button || selectedButton;
        if (btnData.buttonProp?.popUpModal && !onlyPostSubmitAction) {
            return openPopupModal(btnData);
        };
        if (!btnData?.buttonProp?.postSubmitAction) {
            return;
        };
        // if (btnData?.postSubmitActionProp?.action === "clearForm") {
        //   form.resetFields();
        //   console.log("resetFields33");
        // }
        // if (btnData?.postSubmitActionProp?.action === "blankPage") {
        //   setStormResponse(null);
        // };
        let selectedData = [];
        selectedRowData.forEach((x) => {
            selectedData.push(x._id);
        })
        let __urlData = { ...searchParams, ...formData, ...btnData?.postSubmitActionProp?.params, allData: btnData?.postSubmitActionProp?.sendAllData ? [...tblConfig.data] : null, selDocs: JSON.stringify(selectedData) };
        if (response?.data?.data?.selDocid) {
            __urlData.selDocid = response.data.data.selDocid;
            delete __urlData.selDocs;
        };
        if (btnData?.postSubmitActionProp?.action === "reloadStorm") {
            if (document.getElementById("phantomPrimeSbmt")) {
                return document.getElementById("phantomPrimeSbmt").click();
            }
            return fetchTblConfigData({ showLoading: true });
        }
        if (btnData?.postSubmitActionProp?.action === "newTab") {
            let route = createRoute({
                route: btnData.postSubmitActionProp.route,
                props: btnData?.postSubmitActionProp?.props,
                multiProps: btnData?.postSubmitActionProp?.multiProps,
                record: data,
                urlCode,
                params: { ...__urlData },
            });
            return window.open(route, '_blank');
        };

        if (btnData?.postSubmitActionProp?.action === 'reloadPage') {
            return window.location.reload();
        }
        if (btnData?.postSubmitActionProp?.action === 'route') {
            setZenModal({
                typ: "route",
                route: btnData?.postSubmitActionProp?.route,
                width: btnData?.postSubmitActionProp?.width,
                pageTitle: btnData?.postSubmitActionProp?.pageTitle
            });
            toggleModal({
                loading: false,
                show: true,
                data: {
                    urlData: __urlData
                },
                type: "route"
            });
            return;
        }
        if (btnData?.postSubmitActionProp?.action === 'smodal') {
            setZenModal({
                typ: "smodal",
                ...btnData?.postSubmitActionProp
            });
            toggleModal({
                loading: false,
                show: true,
                data: {
                    urlData: __urlData
                },
                type: 'smodal'
            });
            return;
        };
        if (btnData?.postSubmitActionProp?.api) {
            setZenModal({
                typ: btnData?.postSubmitActionProp?.action,
                ...btnData?.postSubmitActionProp
            });
            toggleModal({ show: true, loading: true, type: btnData?.postSubmitActionProp?.action });
            liracrypt.get(`${btnData?.postSubmitActionProp?.api}`, __urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (btnData?.postSubmitActionProp?.action === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: btnData?.postSubmitActionProp?.action
                })
            });
            return;
        }
        finalAction(btnData?.postSubmitActionProp?.action, response)
    };

    const downloadDocs = (btn) => {
        let button = btn || selectedButton;
        if (selectedRowData.length <= 0) return;
        selectedRowData.forEach(x => {
            let urlData = { ...searchParams, ...formData, ...btn.fileDownload.params };
            if (btn.fileDownload.props) {
                urlData[btn.fileDownload.props] = x[btn.fileDownload.props];
            }
            urlData['token'] = localStorage.getItem("token");
            urlData['urlCode'] = urlCode;
            let _searchParams = new URLSearchParams(urlData);
            document.getElementById('downloadLink').setAttribute("href", `${process.env.REACT_APP_API_ENDPOINT}${btn.fileDownload.api}?${_searchParams}`);
            document.getElementById('downloadLink').click();
        })
    }

    const openPopupModal = (button) => {
        setIsHModalVisible(true);
        setAction({ edit: button.popUpModalProp });
    };

    const onFinish = async ({ button }) => {
        if (tblConfig.config.tableConfig.isCheckable && selectedRowData.length <= 0 && button?.submitFormDataProp?.selDocsRequired) {
            return notification.warning({ message: "Please select atleast one record", position: 'top' });
        }
        let { method, api, params } = button?.submitFormDataProp;
        let urlData = { ...searchParams, ...formData, ...params };
        try {
            let response;
            let postData = { ...urlData };
            postData.seldocs = selectedRowData;
            if (button?.submitFormDataProp?.sendAllData) {
                postData = { ...postData, allData: tblConfig.data };
            }
            if (method === 'POST') {
                response = await liracrypt.post(api, { ...postData });
            }
            if (method === 'PATCH') {
                response = await liracrypt.patch(api, { ...postData });
            }
            if (method === 'DELETE') {
                response = await liracrypt.delete(api, { ...postData });
            }
            if (response?.data?.isSuccess) {
                notification.success({ message: response.data.message });
                if (button?.buttonProp?.relayTask) {
                    return relayTask({ button, resp: response });
                }
                onResponse({ button, response })
            } else {
                notification.error({ message: response.data.message })
            }
        } catch (err) {
            console.error(err);
            ApiErrorComp();
        }
    }

    const onScanterFinish = ({ button, barCode }) => {

        let postData = { ...searchParams, ...formData, ...button?.submitFormDataProp.params };
        postData.barCode = barCode;
        postData.seldocs = selectedRowData;
        setBarCode(barCode);
        if (button?.submitFormDataProp?.method === 'POST') {
            liracrypt.post(button?.submitFormDataProp.url, postData).then(response => {
                if (response.data.isSuccess) {
                    notification.success({ message: response.data.message });
                    onResponse({ button, response })
                } else {
                    notification.error({ message: response.data.message })
                }

            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
        if (button?.submitFormDataProp?.method === 'PATCH') {
            liracrypt.patch(button?.submitFormDataProp.url, postData).then(response => {
                if (response.data.isSuccess) {
                    notification.success({ message: response.data.message });
                    onResponse({ button, response })
                } else {
                    notification.error({ message: response.data.message })
                }
            })
                .catch(err => {
                    notification.error({
                        message: 'Something went wrong'
                    })
                })
        };
    }

    const ApiAction = (formula, data) => {
        if (formula["method"] === "PATCH") {
            liracrypt
                .patch(formula["url"], data)
                .then((res, req) => {
                    finalAction(formula["action"], res);
                })
                .catch((err) => {
                    notification.error({ message: "Oops.. Something went wrong !" });
                })
                .finally(() => {
                    setBtnLoading({
                        ...btnloading,
                        [btnloading[formula["label"]]]: false,
                    });
                });
        } else if (formula["method"] === "POST") {
            liracrypt
                .post(formula["url"], data)
                .then((res, req) => {
                    finalAction(formula["action"], res);
                })
                .catch((err) => {
                    notification.error({ message: "Oops.. Something went wrong !" });
                })
                .finally(() => {
                    setBtnLoading({
                        ...btnloading,
                        [btnloading[formula["label"]]]: false,
                    });
                });
        }
    };

    const checkPatchData = (formula, data) => {
        setBtnLoading({ ...btnloading, [btnloading[formula["label"]]]: true });

        if (formula["confirmationPopUp"]) {
            Modal.confirm({
                title: formula["confirmationPopUp"]["text"],
                icon: <ExclamationCircleOutlined />,
                okText: formula["confirmationPopUp"]["okButtonLabel"],
                cancelText: formula["confirmationPopUp"]["cancelButtonLabel"],
                cancelButtonProps: { ghost: true },
                okButtonProps: { ghots: true, danger: true },
                onOk: () => {

                    ApiAction(formula, data);
                },
            });
        } else if (formula["popUpModal"]) {
            setModalMethod(formula["method"]);
            setAction({
                edit: {
                    url: formula["popUpModal"]["url"],
                    method: formula["popUpModal"]["method"],
                    modalHeader: formula["popUpModal"]["modalHeader"],
                    modalElements: formula["popUpModal"]["modalElements"],
                },
            });
            setIsHModalVisible(true);
        } else {
            ApiAction(formula, data);
        }
    };

    const openSmodal = (btnData) => {
        setZenModal(btnData.smodalProp);
        let selectedData = [];
        selectedRowData.forEach((x) => {
            selectedData.push(x._id);
        })
        let urlData = { ...searchParams, ...formData, ...btnData?.smodalProp?.params, seldocs: JSON.stringify(selectedData) };
        // if (btnData.smodalProp?.multiProps?.length) {
        //   btnData.smodalProp?.multiProps.forEach(x => {
        //     urlData[x] = form.getFieldValue(x);
        //   })
        // }
        return toggleModal({
            show: true,
            data: {
                urlData: { ...urlData }
            },
            type: 'smodal',
            loading: false
        });
    }

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows, info) => {
            setSelectedRowData(selectedRows)
            // console.log(selectedRows, selectedRowKeys);
        },
        // onSelect: (record, selected, selectedRows) => {
        //     setSelectedRowData(selectedRows);
        // },
        // onSelectAll: (selected, selectedRows, changeRows) => {
        //     setSelectedRowData(selectedRows);
        // },
    };
    return data.tblConfig && data.column && data.data && mount ? (
        <div className={`zen-table-prime ${widthClass}`} style={getDivStyle()}>
            {
                tblConfig.config?.headerImageCorousel ?
                    <ImageSlideShow config={tblConfig.config?.headerImageCorousel?.config} data={tblConfig.config?.headerImageCorousel?.data || ["SF_014-0", "SF_013-0", "SF_012-0", "SF_011-0"]} src={tblConfig.config?.headerImageCorousel?.src || 'data'} params={tblConfig.config?.headerImageCorousel?.params} api={tblConfig.config?.headerImageCorousel?.api} /> :
                    <></>
            }
            {
                tblConfig.config?.headerImg ?
                    <ImgDisplay api={tblConfig.config?.headerImg?.api || '/imagecontrol'} style={tblConfig.config?.headerImg?.style} params={{ ...formData, ...tblConfig.config?.headerImg?.params }} /> : null
            }
            {
                tblConfig.config?.scrollBlock ?
                    <ScrollBlock style={tblConfig.config?.scrollBlock.style} text={tblConfig.config?.scrollBlock.text} animation={tblConfig.config?.scrollBlock.animation} /> :
                    <></>
            }
            <ZenMultiLines style={{ backgroundColor: tblConfig.config.headerMultiline?.['background-color'] || 'transparent' }} classes="zen-multi-header" visible={tblConfig?.config?.zenFuncs?.headerMultiline || false} singleLineColumns={tblConfig?.config?.headerMultiline?.singleCol || []} multiLineColumns={tblConfig?.config?.headerMultiline?.multiCol || []} />
            <Modal
                title={relayTaskModal.title || "Relay Task XXXXX"}
                maskClosable={false}
                open={relayTaskModal.visible}
                className={"zen-modal"}
                closable={relayTaskModal.closable || false}
                onCancel={() => setRelayTaskModal({ visible: false })}
                okButtonProps={{ disabled: true, hidden: true }}
                cancelButtonProps={{ disabled: true, hidden: true }}
            >
                <p style={{ ...relayTaskModal?.msgStyle }}>{relayTaskModal.msg}</p>
            </Modal>
            {
                data.tblConfig.tableTitle["title-label"] && (
                    <p
                        style={{
                            ...getStyleProperties(data.tblConfig.tableTitle),
                        }}
                    >
                        {data.tblConfig.tableTitle["title-label"]}
                    </p>
                )
            }

            {
                tblConfig?.config?.tableSubTitle?.visible && (
                    <React.Fragment>
                        <GetTable d={modData ? modData : data.data} />
                    </React.Fragment>
                )
            }

            <ModalView />


            <TableModal
                stableAuxData={stableAuxData}
                stableType={stableType}
                stableUrl={stableUrl}
                setStableModalVisible={setStableModalVisible}
                stableModalVisible={stableModalVisible}
                record={record}
            />

            <HModal
                submitBtnId={'submitBtnModal'}
                barCode={barCode}
                preventSubmitBtnClick={false}
                onResponse={onResponse}
                isModalVisible={isHModalVisible}
                setIsModalVisible={setIsHModalVisible}
                modalMethod={"edit"}
                urlData={{ ...formData }}
                action={action}
                modalData={null}
                extraData={{ seldocs: selectedRowData }}
            />

            <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} smodalCallback={onResponse} />

            {/* Route Modal */}
            <ZenModal modal={{
                type: routeModalData?.type,
                show: routeModalData?.show
            }}
                zenModal={{
                    title: routeModalData?.title,
                    width: routeModalData?.width,
                    route: routeModalData?.route,
                    params: routeModalData?.urlData
                }}
                toggleModal={toggleRouteModal}
            />

            {
                tblConfig.config.tableConfig.visible && (
                    <Table
                        loading={tblLoading}
                        locale={{
                            emptyText:
                                <div className="ant-empty ant-empty-normal">
                                    <div className="ant-empty-description">No data</div>
                                </div>
                        }}
                        showSorterTooltip={false}
                        filterSearch={true}
                        showHeader={tblConfig?.config?.header?.visible}
                        rowClassName={(record) => record?.rowCol || ''}
                        columns={tblConfig.config.isGroupedColumns ? undefined : data.column}
                        scroll={{ x: 300, y: tabeLimitPerPage > 15 ? 500 : undefined }}
                        dataSource={data.searchData}
                        rowKey="_id"
                        rowSelection={
                            tblConfig.config.tableConfig.isCheckable ? rowSelection : null
                        }
                        className={`${tblClass} zenTablePrime gx-table-responsive`}
                        // summary={(da) => {

                        //     setModData(da);
                        // }}
                        footer={() => (
                            <>
                                <ZenMultiLines classes="zen-multi-footer" visible={tblConfig?.config?.zenFuncs?.footerMultiline || false} singleLineColumns={tblConfig?.config?.footerMultiline?.singleCol || []} multiLineColumns={tblConfig?.config?.footerMultiline?.multiCol || []} />
                            </>
                        )}
                        pagination={tblConfig.config.footer['visible'] ? {
                            className: tblConfig.config.footer['pageNo-visible'] ? "show-pagination" : "hide-pagination",
                            showSizeChanger: tblConfig.config.footer['noOfRows-visible'] ? true : false,
                            onShowSizeChange: (_, size) => setTableLimitPerPage(size),
                            defaultPageSize: tabeLimitPerPage,
                            current: defaultPage,
                            onChange: (e) => setDefaultPage(e)
                        } : false}
                    >
                        {
                            tblConfig.config.isGroupedColumns ?
                                tblConfig.config.groupedColumns.map((g, i) => (
                                    <ColumnGroup key={`grouped-column-${i}`} className="table-group-header" title={g.title}>
                                        {
                                            g.columns.map((col, colI) => {
                                                const x = data.column.find(y => y.dataIndex === col.data_index);
                                                return (
                                                    <Column align={x?.align} key={`grouped-column-col-${colI}`} render={x?.render} className={x?.className} fixed={x?.fixed} title={x?.title} dataIndex={x?.dataIndex} width={x?.width} sorter={x?.sorter} />
                                                )
                                            })
                                        }
                                    </ColumnGroup>
                                )) : <></>
                        }

                    </Table>
                )
            }

            <>
                {
                    tblConfig.config?.footerImageCorousel ?
                        <ImageSlideShow config={tblConfig.config?.footerImageCorousel?.config} data={tblConfig.config?.footerImageCorousel?.data} src={tblConfig.config?.footerImageCorousel?.src || 'data'} params={tblConfig.config?.footerImageCorousel?.params} api={tblConfig.config?.footerImageCorousel?.api} /> :
                        <></>
                }
                {
                    tblConfig.config.scanter?.buttonProp?.enable && (
                        <div style={{ width: '100%', marginTop: 10 }}>
                            <Scanter
                                onFinish={onScanterFinish}
                                postSubmitAction={onResponse}
                                openPopupModal={openPopupModal}
                                button={tblConfig.config.scanter}
                                setSelectedButton={setSelectedButton}
                                form={null}
                                label={tblConfig.config.scanter?.buttonProp?.label}
                                type={tblConfig.config.scanter?.buttonProp?.type}
                                disabled={!tblConfig.config.scanter?.buttonProp?.enable}
                                confirmationPopUp={tblConfig.config.scanter?.buttonProp?.confirmationPopUp ? tblConfig.config.scanter?.confirmationPopUpProp : undefined}
                                submitFormData={tblConfig.config.scanter?.submitFormDataProp}
                            />
                        </div>
                    )
                }

                {tblConfig.config.buttons ?
                    <div
                        style={{
                            marginTop: "10px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >

                        {tblConfig?.config?.buttons.map((bItem, index) => {
                            return (
                                <Button
                                    id="submitButtonForm"
                                    style={{
                                        fontWeight: 600,
                                        borderRadius: "10px",
                                        margin: "5px",
                                        marginRight: "10px",
                                        backgroundColor:
                                            bItem["type"] === "warning" ? "#fcba03" : "",
                                        borderColor: bItem["type"] === "warning" ? "#fcba03" : "",
                                        color: "#fff",
                                    }}
                                    loading={
                                        btnloading[bItem["label"]]
                                            ? btnloading[bItem["label"]]
                                            : false
                                    }
                                    type={
                                        bItem["type"] === "primary"
                                            ? "primary"
                                            : bItem["type"] === "danger"
                                                ? "danger"
                                                : ""
                                    }
                                    onClick={() => {

                                        // checkPatchData(bItem, modData);

                                        checkPatchData(bItem, selectedRowData);
                                    }}
                                >
                                    {bItem["label"]}
                                </Button>
                            );
                        })}
                    </div> : <></>}
                {
                    tblConfig?.config?.zenFuncs?.footerButtons && (
                        <div
                            style={{
                                marginTop: "10px",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {tblConfig.config.footerButtons && (
                                Object.keys(tblConfig.config.footerButtons).map((btn, index) => {
                                    const button = tblConfig.config.footerButtons[btn];
                                    if (button?.buttonProp?.visible) {
                                        return (
                                            <React.Fragment key={index}>
                                                <FooterButtons
                                                    downloadDocs={downloadDocs}
                                                    openSmodal={openSmodal}
                                                    onFinish={onFinish}
                                                    postSubmitAction={onResponse}
                                                    openPopupModal={openPopupModal}
                                                    button={button}
                                                    setSelectedButton={setSelectedButton}
                                                    form={null}
                                                    label={button?.buttonProp?.label}
                                                    type={button?.buttonProp?.type}
                                                    disabled={!button?.buttonProp?.enable}
                                                    confirmationPopUp={button?.buttonProp?.confirmationPopUp ? button?.confirmationPopUpProp : undefined}
                                                    submitFormData={button?.submitFormDataProp}
                                                />
                                            </React.Fragment>
                                        )
                                    }
                                })
                            )}
                        </div>
                    )
                }
                <a style={{ position: 'absolute' }} target="_blank" id="downloadLink" href="" download={true}>Test</a>
            </>
        </div >
    ) : (
        <></>
    );
};

export default ZenTablePrime;